module.exports = __webpack_public_path__ + "media/assets/cloudroom-chrome-71091b44014a044405fa541cf8a213e3.png";